import { render, staticRenderFns } from "./Puntos.vue?vue&type=template&id=427e296e&"
import script from "./Puntos.vue?vue&type=script&lang=js&"
export * from "./Puntos.vue?vue&type=script&lang=js&"
import style0 from "./Puntos.vue?vue&type=style&index=0&id=427e296e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports